import { DSBottomSheet } from '@repo/design-system/index'
import { isFunction } from 'lodash'
import { useEffect, useState } from 'react'
import useModalBackButton from '../../../modules/hooks/common/useModalBackButton'
import usePopupStore from '../../../store/usePopupStore'

export const useBottomSheet = () => {
  const popupShow = usePopupStore((state) => state.show)
  const popupClose = usePopupStore((state) => state.close)

  const show = (props) => {
    popupShow({ ...props, type: 'bottom-sheet' })
  }

  const close = (id) => {
    popupClose({ id })
  }

  return { show, close }
}

export const BottomSheet = ({ id }: { id: any }) => {
  const [open, setOpen] = useState(true)
  const popupClose = usePopupStore((state) => state.close)

  const { data, isShow } = usePopupStore((state) => ({
    data: state.data[id],
    isShow: state.isPopupRendered,
  }))

  const {
    onClose = null,
    onOutsideClose = null,
    bottombarContent = null,
    body = undefined,
    closeButton = true,
    closeOnDim = false,
    closeOnDrag = false,
    enableScroll = false,
    noDim = false,
    zIndex = '2147483647',
    noScrollbar = true,
  } = data ? data : {}

  const closeHandler = () => {
    popupClose({ id })
    setOpen(false)
    if (isFunction(onClose)) {
      onClose()
    }
  }
  useModalBackButton(id, isShow)

  useEffect(() => {
    return () => {
      popupClose({ id })
    }
  }, [])

  return (
    <div id={id}>
      <DSBottomSheet
        id={id}
        isOpen={open}
        setIsOpen={setOpen}
        closeButton={closeButton}
        closeOnDim={closeOnDim}
        closeOnDrag={closeOnDrag}
        enableScroll={enableScroll}
        noDim={noDim}
        zIndex={zIndex}
        onClose={() => closeHandler()}
        noScrollbar={noScrollbar}
      >
        {body}
        {bottombarContent}
      </DSBottomSheet>
    </div>
  )
}
